import { Navbar } from 'react-bootstrap';
import NavbarBrand from 'components/navbars/nav-items/NavbarBrand';
import NavItems from 'components/navbars/nav-items/NavItems';

const NavbarTopDefault = () => {
  return (
    <Navbar className="navbar-top" expand variant="">
      <div className="navbar-collapse justify-content-between">
        <NavbarBrand />
        <NavItems />
      </div>
    </Navbar>
  );
};

export default NavbarTopDefault;
